(ns rothko.theme.manatee.core
  (:require [rothko.theme.manatee.accordion :as accordion]
            [rothko.theme.manatee.collection-components.table :as table]
            [rothko.theme.manatee.editor.component :as editor-component]
            [rothko.theme.manatee.editor.document :as editor-document]
            [rothko.theme.manatee.editor.edit :as editor-edit]
            [rothko.theme.manatee.editor.space :as editor-space]
            [rothko.theme.manatee.editor.tag :as editor-tag]
            [rothko.theme.manatee.editor.toolbar :as editor-toolbar]
            [rothko.theme.manatee.editor.word :as editor-word]
            [rothko.theme.manatee.audio.mini-player :as mini-player]
            [rothko.theme.manatee.audio.wave-player :as wave-player]
            [rothko.theme.manatee.button :as button]
            [rothko.theme.manatee.footer :as footer]
            [rothko.theme.manatee.form.checkbox :as checkbox-theme]
            [rothko.theme.manatee.form.input :as input-theme]
            [rothko.theme.manatee.form.radio :as radio-theme]
            [rothko.theme.manatee.form2.label :as label-theme]
            [rothko.theme.manatee.form2.select.multi-select :as multi-select-theme]
            [rothko.theme.manatee.form2.select.single-select :as single-select-theme]
            [rothko.theme.manatee.form2.slider :as slider-theme]
            [rothko.theme.manatee.form2.validation-message :as validation-message-theme]
            [rothko.theme.manatee.header :as header]
            [rothko.theme.manatee.hideable-container :as hideable-container]
            [rothko.theme.manatee.layout :as layout]
            [rothko.theme.manatee.link :as link]
            [rothko.theme.manatee.nav :as nav]
            [rothko.theme.manatee.panel :as panel]
            [rothko.theme.manatee.tabber :as tabber]
            [rothko.theme.manatee.tooltip :as tooltip]))

(def main
  {:styles
   {:rothko.accordion.component/accordion accordion/main
    :rothko.collection-components.table.component/column-name table/column-name
    :rothko.collection-components.table.component/body table/body
    :rothko.collection-components.table.component/field table/field
    :rothko.collection-components.table.component/footer table/footer
    :rothko.collection-components.table.component/header table/header
    :rothko.collection-components.table.component/row table/row
    :rothko.editor.component/editor editor-component/main
    :rothko.editor.document.component/document editor-document/main
    :rothko.editor.edit.component/edit editor-edit/main
    :rothko.editor.space.component/space editor-space/main
    :rothko.editor.tag.component/tag editor-tag/main
    :rothko.editor.word.component/word editor-word/main
    :rothko.audio.mini-player.component/mini-player mini-player/main
    :rothko.audio.wave-player.component/progress-bar wave-player/progress-bar
    :rothko.audio.wave-player.component/controls wave-player/controls
    :rothko.audio.wave-player.component/titles wave-player/titles
    :rothko.audio.wave-player.component/wave-player wave-player/wave-player
    :rothko.button.component/button button/main
    :rothko.footer.component/footer footer/main
    :rothko.form.checkbox.component/checkbox checkbox-theme/checkbox
    :rothko.form.radio.component/radio radio-theme/radio
    ;; Form v2 theming
    :rothko.form2.input.component/input input-theme/input
    :rothko.form2.label.component/label label-theme/label
    :rothko.form2.select.multi-select.component/field multi-select-theme/select
    :rothko.form2.select.single-select.component/field single-select-theme/select
    :rothko.form2.slider.component/slider-group-input slider-theme/slider-group-input
    :rothko.form2.validation-message.component/validation-message validation-message-theme/validation-message
    :rothko.header.component/main header/main
    :rothko.hideable-container.component/hideable-container hideable-container/main
    :rothko.layout.component/main layout/main
    :rothko.link.component/link link/link
    :rothko.nav.component/footer-item nav/footer-item
    :rothko.nav.component/nav nav/nav
    :rothko.nav.component/nav-item nav/nav-item
    :rothko.panel.component/panel panel/main
    :rothko.tabber.component/tabber tabber/main
    :rothko.tooltip.component/tip tooltip/tip}})
